module.exports = __webpack_public_path__ + "img/dajuya.ac1e1130.png";